import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ApproveP2b, selectApprovalDetail } from "store/slices/approvalPage";

import { ApproveDecisioning, ApproveMonitoring } from "store/slices/approvalPage";
import ThankYouComponent from "components/common/ThankYouComponent";

const ApprovalPage = () => {
  const dispatch = useDispatch();
  const approveRequest = useSelector(selectApprovalDetail);
  const { url, requestId, status } = useParams();
  let content = "Your response has already been recorded";
  let page = url.includes("decisioning") ? "Decisioning" : url.includes("monitoring") ? "Monitoring" : "P2B";
  let approvalStatus = status === "approved" ? "approved" : "declined";

  useEffect(() => {
    const approveStatus = status === "approved" ? "A" : "D";

    if (url.includes("decisioning")) {
      dispatch(ApproveDecisioning(requestId, approveStatus));
    } else if (url.includes("monitoring")) {
      dispatch(ApproveMonitoring(requestId, approveStatus));
    } else {
      dispatch(ApproveP2b(requestId, approveStatus));
    }
  }, [requestId, status, url, dispatch]);

  if (approveRequest) {
    content = `Request to apply changes to ${page} Configurations has been ${approvalStatus}. You may close the window.`;
  }

  return <ThankYouComponent content={content} />;
};

export default ApprovalPage;
